import { ThemeProvider } from '@dittolive/anvil'
import * as Sentry from '@sentry/browser'
import AppEntry from 'AppEntry'
import Auth0PortalProvider from 'Auth0PortalProvider'
import { ErrorFallback } from 'components/error'
import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { EmailConfirmationPendingScene } from 'scenes/emailConfirmation'
import { EmailVerificationScene, PortalLoginScene } from 'scenes/login'
import { LegacyAuth0Entry } from 'scenes/login/LegacyAuth0Entry'
import UnsupportedBrowserScene from 'scenes/unsupportedBrowser/UnsupportedBrowserScene'
import { isSupportedBrowser } from 'utils/browserSupport'
import { StaticNavigateProvider } from 'utils/navigate'
import { isBetterAuthEnabled, PortalAuthProvider } from 'utils/portalAuth'

export default function App() {
  const renderApp = () => {
    if (isSupportedBrowser()) {
      return (
        <Routes>
          {isBetterAuthEnabled() && (
            <>
              <Route
                path="/login"
                element={<PortalLoginScene mode="login" />}
              />
              <Route
                path="/login/callback"
                element={<PortalLoginScene mode="login" callback />}
              />
              <Route path="/login/auth0" element={<LegacyAuth0Entry />} />
              <Route
                path="/signup"
                element={<PortalLoginScene mode="signup" />}
              />
              <Route
                path="/create-account"
                element={<PortalLoginScene mode="signup" />}
              />
              <Route
                path="/verify-email"
                element={<EmailVerificationScene />}
              />
            </>
          )}
          <Route
            path="/email-verification-pending"
            element={<EmailConfirmationPendingScene />}
          />
          <Route path="*" element={<AppEntry />} />
        </Routes>
      )
    } else {
      return <UnsupportedBrowserScene />
    }
  }

  const handleAppError = (error: Error, errorInfo: React.ErrorInfo) => {
    Sentry.withScope((scope) => {
      Object.entries(errorInfo).forEach(([key, value]) => {
        scope.setExtra(key, value)
      })
      Sentry.captureException(error)
    })
  }

  return (
    <ThemeProvider>
      <BrowserRouter>
        <StaticNavigateProvider>
          <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onError={handleAppError}
          >
            <Auth0PortalProvider>
              <PortalAuthProvider>{renderApp()}</PortalAuthProvider>
            </Auth0PortalProvider>
          </ErrorBoundary>
        </StaticNavigateProvider>
      </BrowserRouter>
    </ThemeProvider>
  )
}
